import TestEvent from "./models/TestEvent"
import { ObservableFromFetch } from "./ObservableFromFetch"

export const getTestEvents = () => ObservableFromFetch<TestEvent[]>(`Results/TestEvents`)
export const setViewed = (testEventId: number) => ObservableFromFetch<void>('Results/Viewed', testEventId.toString())
